import * as exTable from '../../table';

// ----------------------------------------------------------------------------

function refresh(element: HTMLElement, config: Record<string, any> = {}): void {
    exTable.refresh(element, config);
}

// ----------------------------------------------------------------------------

export { refresh };
